import { render, staticRenderFns } from "./ListaEntregas.vue?vue&type=template&id=f1de70a4&scoped=true"
import script from "./ListaEntregas.vue?vue&type=script&lang=js"
export * from "./ListaEntregas.vue?vue&type=script&lang=js"
import style0 from "./ListaEntregas.vue?vue&type=style&index=0&id=f1de70a4&prod&lang=css"
import style1 from "./ListaEntregas.vue?vue&type=style&index=1&id=f1de70a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1de70a4",
  null
  
)

export default component.exports